import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {UserService} from '../../../service/UserService';
import { Order } from '../../models/order';
import { DataService } from '../../../service/data.service';
import { HttpErrorResponse } from '@angular/common/http';
import { User } from '../../../shared/models/user'; 

@Component({
  selector: 'app-checkout-form',
  templateUrl: './checkout-form.component.html',
  styleUrls: ['./checkout-form.component.scss']
})
export class CheckoutFormComponent implements OnInit {
  hide = true;
  token: string | null = null;
  error = "";
  imageUrl: string | null = null;
  randomNumber: any;
  orderId: string | null = null;

  isProcessingOrder: boolean = false;
  orderConfirmed: boolean = false;

  // **Nuevas propiedades para la funcionalidad de 'olvidé mi contraseña'**
  showForgotPassword = false;
  loading = false;
  message = '';
  email: string = '';

  // **Se agregó una propiedad para guardar la información del usuario logeado**
  user: any;

  private readonly WELCOME_PROMO_CODE_ID = 'NEW-CLIENT';
  loadingRegister = false;

  constructor(private router: Router,
              private userService: UserService,
              private data: DataService,
              private cdr: ChangeDetectorRef) { } // Removed CheckoutService injection

  ngOnInit(): void {
    this.token = localStorage.getItem('token');
    if(this.token != null){
        this.validationLogin(this.token);
    }
      const savedAddress = localStorage.getItem('addressCheckOut');
      if (savedAddress) {
        const address = JSON.parse(savedAddress);
        this.addressCheckOut.patchValue(address);
      }

      this.addressCheckOut.get('country')?.setValue('Mexico');

      this.obtenerUrlDeImagen();
      this.obtenerRandomNumber();
  }

  contactForm = new FormGroup({
    email: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    phoneD: new FormControl('', Validators.required)
  });

  addressCheckOut = new FormGroup({
    name: new FormControl('',Validators.required),
    phone: new FormControl('',Validators.required),
    street: new FormControl('',Validators.required),
    number: new FormControl('',Validators.required),
    colony: new FormControl('',Validators.required),
    municipality: new FormControl('',Validators.required),
    state: new FormControl('',Validators.required),
    zipCode: new FormControl('',Validators.required),
    country: new FormControl('Mexico',Validators.required)
    });

  toggleForgotPassword(): void {
    this.showForgotPassword = !this.showForgotPassword;
    this.message = '';
    this.contactForm.reset();
    this.error = '';
  }

  // Valida que email y password estén llenos (para Login)
  isLoginFormInvalid(): boolean {
    const email = this.contactForm.get('email');
    const password = this.contactForm.get('password');
    return !email?.value || !password?.value;
  }

  // Valida que email, password y phoneD estén llenos (para Registro)
  isRegisterFormInvalid(): boolean {
    const email = this.contactForm.get('email');
    const password = this.contactForm.get('password');
    const phoneD = this.contactForm.get('phoneD');
    return !email?.value || !password?.value || !phoneD?.value;
  }

  resetPassword(): void {
    if (!this.email) {
      this.message = 'Por favor, ingrese su correo electrónico.';
      return;
    }

    this.loading = true;
    this.message = '';
    this.userService.resetPassword(this.email).subscribe(
      (response: any) => {
        this.loading = false;
        this.message = 'Enlace de restablecimiento enviado a su correo electrónico.';
        this.cdr.detectChanges();
      },
      (error) => {
        this.loading = false;
        console.error('Error al restablecer la contraseña:', error);
        this.message = 'Hubo un error. Revise su correo o intente de nuevo más tarde.';
        this.cdr.detectChanges();
      }
    );
  }

  // **Se modificó onLogin para llamar a validationLogin después de guardar el token**
  onLogin(): void {
    if (this.contactForm.get('email')?.invalid || this.contactForm.get('password')?.invalid) {
      this.error = "Email y contraseña requeridos.";
      return;
    }
     const { email, password } = this.contactForm.value;
     const emailStr = email || '';
     const passwordStr = password || '';

    this.userService.login(emailStr, passwordStr)
      .then(response => {
        localStorage.setItem('token', response.data.token);
        this.validationLogin(response.data.token); // Llama a validationLogin con el nuevo token
        this.router.navigate(['/secure-checkout']).then(() => {
          window.location.reload();
        });
      })
      .catch(error => {
        this.contactForm.reset();
        this.error = "Usuario o contraseña incorrecto";
      })
  }

   register(): void {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      this.error = "Por favor, completa todos los campos obligatorios.";
      this.message = ""; 
      return;
    }

    const { email, password, phoneD } = this.contactForm.value;
    const emailStr = email || '';
    const passwordStr = password || '';
    const phoneStr = phoneD || '';

    this.loadingRegister = true;
    this.userService.register(emailStr, passwordStr)
      .then(async (response) => {
        localStorage.setItem('token', response.data.token);
        const userValidationResponse = await this.userService.validationLogin(response.data.token);
        const user = userValidationResponse.data;
        localStorage.setItem('cliente', JSON.stringify(user));

        const newUser: User = {
          id: user.uid,
          email: emailStr,
          user: user.uid,
          phone: phoneStr 
        };

        // Guardar en el microservicio de usuarios
        this.userService.addUser(newUser).subscribe({
          next: (addResponse) => {
            // Guardar promoción de bienvenida
            this.userService.saveUserPromotion(user.uid, emailStr, this.WELCOME_PROMO_CODE_ID)
              .subscribe({
                next: () => {
                  this.message = '¡Registro exitoso! ¡Ya puedes usar tu cupón de bienvenida!';
                  this.finalizarRegistroExitoso();
                },
                error: (error: HttpErrorResponse) => {
                  this.message = '¡Registro exitoso! Pero hubo un detalle con tu cupón.';
                  this.finalizarRegistroExitoso();
                }
              });
          },
          error: (addError) => {
            this.error = "Error al guardar perfil de usuario.";
            this.loadingRegister = false;
          }
        });
      })
      .catch(error => {
        this.contactForm.reset();
        this.error = "Ya se encuentra registrada esa cuenta.";
        this.loadingRegister = false;
      });
  }

  private finalizarRegistroExitoso() {
    this.loadingRegister = false;
    setTimeout(() => {
      // En el checkout, después de registrar, recargamos para mostrar el form de envío
      window.location.reload(); 
    }, 2000);
  }

  private getErrorMnsFromError(err : any) {
    if (err && err.error) {
      let errorObject: any;
      if (typeof err.error == 'string') {
        try {
          errorObject = JSON.parse(err.error);
        } catch (ex) {
        }
      } else if (typeof err.error == 'object') {
        errorObject = err.error;
      }
      if (errorObject && errorObject.localizedMessage) {
        return errorObject.localizedMessage;
      }
    }
    return '';
  }

  // **Se modificó validationLogin para guardar la info del usuario en una propiedad**
  validationLogin(token: string) {
    this.userService.validationLogin(token)
      .then(response => {
         localStorage.setItem('cliente', JSON.stringify(response.data));
         this.user = response.data; // Se guarda la información del usuario en 'this.user'
      })
      .catch(error => {
         this.error = "No estas logeado";
      })
  }

  personalData(): void {
    const addressFormValue = this.addressCheckOut.value;
    const addressFormValueJson = JSON.stringify(addressFormValue);
    localStorage.setItem('addressCheckOut', addressFormValueJson);
   }

  regresar(): void {
    this.router.navigate(['/payments']);
   }

  confirmPedido() {
    this.addressCheckOut.markAllAsTouched();
    if (this.addressCheckOut.invalid) {
        return;
    }

    this.personalData();
    this.isProcessingOrder = true;
    const currentDate = new Date().toISOString().replace(/\.\d{3}Z$/, '000000Z');
    try {
      const addressCheckOut = JSON.parse(localStorage.getItem('addressCheckOut') || '{}');
      const cartItems = JSON.parse(localStorage.getItem('cartItems') || '[]');
      
      // Obtener los datos desde localStorage
      const subtotal = Number(localStorage.getItem('subtotal'));
      const granTotal =  Number(localStorage.getItem('granTotal'));
      const descuento = Number(localStorage.getItem('descuento'));
      const cuponAplicado = localStorage.getItem('cupon') || '';
      
      const envio = JSON.parse(localStorage.getItem('envio') || '0');
      const createAtPlus5BusinessDays = sessionStorage.getItem('createAtPlus5BusinessDays') || 'N/A';
      const createAtPlus20BusinessDays = sessionStorage.getItem('createAtPlus20BusinessDays') || 'N/A';
      
      const order: Order = {
        user: this.user?.uid || '',
        email: this.user?.email || "email@default.com",
        name: addressCheckOut.name || "Nombre por defecto",
        phone: addressCheckOut.phone || "0000000000",
        street: addressCheckOut.street || "Calle",
        numberHome: addressCheckOut.number || "000",
        colony: addressCheckOut.colony || "Colonia",
        city: addressCheckOut.municipality || "Municipio",
        state: addressCheckOut.state || "Estado",
        zipCode: addressCheckOut.zipCode || "00000",
        country: addressCheckOut.country || "Mexico",
        status: "Orden confirmada",
        deliveryDate: "2024-09-15T05:08:11.831000000Z",
        createAtPlus5BusinessDays: createAtPlus5BusinessDays,
        createAtPlus20BusinessDays: createAtPlus20BusinessDays,
        observations: "Observaciones sobre el pedido",
        shippingMethod: "Envio",
        shippingType: "Estandar",
        shippingCost: envio,
        parcelName: "-",
        guideNumber: "-",
        total: granTotal,
        subtotal: subtotal,
        discount: descuento,
        tax: 0,
        totalPayment: granTotal,
        urlFile: "URL de archivo detalle de pedido",
        products: cartItems,
        pay: [
          {
            methodPay: "Transferencia",
            amount: granTotal.toString(),
            status: "Validando pago",
            concepto: this.randomNumber,
            description: "Validando la transferencia",
            urlPay: this.imageUrl || '',
            comentary: "Comentarios sobre el pago"
          }
        ],
        origin: "ecommerce-camben",
        promoCodeApplied: cuponAplicado // Campo nuevo del cupón
      };

      this.data.createOrder(order).subscribe(response => {
        //this.orderId = response.data.id || response.data.orderId;
        this.data.clearCart();
        localStorage.removeItem('cartItems');
        localStorage.removeItem('randomNumber');
        localStorage.removeItem('urlImagenComprobante');
      
        this.isProcessingOrder = false;
        this.orderConfirmed = true;

        // Reemplazamos checkoutService.resetValues() por limpiar localStorage relevante
        localStorage.removeItem('granTotal');
        localStorage.removeItem('cupon');
        localStorage.removeItem('subtotal');
        localStorage.removeItem('descuento');
        
      }, error => {
        this.isProcessingOrder = false;
      });
    } catch (error) {
      this.isProcessingOrder = false;
    }
  }

  obtenerUrlDeImagen(): string | null {
    this.imageUrl = localStorage.getItem('urlImagenComprobante');
    if (this.imageUrl) {
      return this.imageUrl;
    } else {
      return null;
    }
  }

  obtenerRandomNumber(): string | null {
    this.randomNumber = localStorage.getItem('randomNumber');
    if (this.randomNumber) {
      return this.randomNumber;
    } else {
      return null;
    }
  }
}
